import styled from "styled-components";
import { 
  Container as RGSContainer, 
  Row as RGSRow, 
  Col as RGSCol 
} from 'react-grid-system';

export const Container  = styled(RGSContainer)`
`;

export const Row  = styled(RGSRow)`
`;

export const Col = styled(RGSCol)`
  height: 650px;
`;